import classNames from 'classnames'
import { ComponentProps, ReactElement } from 'react'

interface Props extends ComponentProps<'svg'> {
  color?: string
}

export function IconSms({ color = 'currentColor', className, ...props }: Props): ReactElement {
  return (
    <svg
      fill="none"
      viewBox="4 4 16 16"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames(className, 'w-[1em] h-[1em]')}
      {...props}
    >
      <path
        d="M18 4H6c-1.102 0-2 .905-2 1.986v9.035c0 1.109.898 1.986 2 1.986h3v2.615c0 .307.352.486.598.305l3.903-2.949h4.5c1.102 0 2-.905 2-1.986V5.986A1.99 1.99 0 0 0 18 4zm-3.106 5.275l-3 3.525c-.134.16-.331.255-.541.236h-.028a.75.75 0 0 1-.53-.221l-1.5-1.511a.76.76 0 0 1 0-1.068c.293-.295.768-.295 1.061 0l.928.934 2.473-2.906c.271-.317.744-.352 1.057-.082.315.299.349.775.08 1.093z"
        fill={color}
      />
    </svg>
  )
}
